import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_URL } from './base-url';

@Injectable({
  providedIn: 'root'
})
export class TicketPriorityDefinitionControllerService {

  base_URL = BASE_URL;

  constructor(private http: HttpClient) { }

  addTicketPriorityDefinition(body: any) {
    return this.http.post(this.base_URL + 'ticketPriorityDefinition', body)
  }

  getAllTicketPriorityDefinition() {
    return this.http.get(this.base_URL + 'ticketPriorityDefinition/all/' + sessionStorage.getItem('cid'))
  }

  deleteTicketPriorityDefinition(id: any) {
    return this.http.delete(this.base_URL + 'ticketPriorityDefinition/softDelete/' + id)
  }

  hardDeleteTicketPriorityDefinition(id: any) {
    return this.http.delete(this.base_URL + 'ticketPriorityDefinition/hardDelete/' + id)
  }

  getTicketPriorityDefinitionById(id: any) {
    return this.http.get(this.base_URL + 'ticketPriorityDefinition/' + id + '/' + sessionStorage.getItem('cid'))
  }

  updateTicketPriorityDefinition(body: any) {
    return this.http.put(this.base_URL + 'ticketPriorityDefinition/update', body)
  }
}
